import React from 'react';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import styles from './ResetConfirmationModal.scss';

const ResetConfirmationModal = ({ header, isOpen, hideModal, body, onClick, cancelBtnText, confirmBtnText }) => (
  <CommonModal
    header={header}
    isOpen={isOpen}
    hideModal={hideModal}
    ariaHideApp={false}
    className={styles.modal}
  >
    <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
    <CommonModal.Body>{body}</CommonModal.Body>
    <CommonModal.Footer>
      <Button onClick={hideModal} className="u-mr20">
        {cancelBtnText}
      </Button>
      <Button onClick={onClick} primary>
        {confirmBtnText}
      </Button>
    </CommonModal.Footer>
  </CommonModal>
);

export default ResetConfirmationModal;
